import axios from "axios";

// iOS (Safari standalone / in-app browser) renders PDFs opened via window.open(blobURL)
// or target="_blank" as a blank page. Fetching as a blob and triggering a real download
// makes the PDF reliably viewable on mobile (opens the native PDF preview) and desktop.
function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "dokument.pdf";
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, 1500);
}

function basename(url) {
  try {
    const clean = url.split("?")[0];
    const name = clean.substring(clean.lastIndexOf("/") + 1);
    return name || "dokument.pdf";
  } catch {
    return "dokument.pdf";
  }
}

// Open a PDF in a new tab for VIEWING (no auto-download). Opens the tab synchronously to avoid popup blockers.
export async function previewPdf(url, { token } = {}) {
  const win = window.open("", "_blank");
  try {
    const res = await axios.get(url, {
      responseType: "blob",
      ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
    });
    const blobUrl = URL.createObjectURL(res.data);
    if (win) {
      win.location = blobUrl;
    } else {
      // Popup blocked — open in same tab rather than force a download.
      window.location.href = blobUrl;
    }
    setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
    return true;
  } catch {
    if (win) win.close();
    alert("Dokument sa nepodarilo načítať. Skúste to znova.");
    return false;
  }
}

// Open any PDF reliably on mobile + desktop. Pass token for protected backend endpoints.
export async function openPdf(url, { filename, token } = {}) {
  try {
    const res = await axios.get(url, {
      responseType: "blob",
      ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
    });
    triggerDownload(res.data, filename || basename(url));
    return true;
  } catch {
    alert("Dokument sa nepodarilo načítať. Skúste to znova.");
    return false;
  }
}
